/**
 * @ngdoc controllers
 * @memberof mercury.modules.settings
 * @name SettingsCompanyImporterCtrl
 */
angular.module('mercury.modules.settings.company')
.controller('SettingsCompanyImporterCtrl', ["dialog", "$http", "ngToast", "$q", "$scope", "$state", "title", "$uibModal", "localStorageService", "settings", function(dialog, $http, ngToast, $q, $scope, $state, title, $uibModal, localStorageService, settings) {
  $scope.registrationPin = '';
  $scope.databases = [];
  $scope.databasesHidden = false;
  var showAllDatabases = false;

  title.set('Avaliable Databases');

  $scope.importerLink = '';

  var createCompanyModal;

  var fetchDatabases = function() {
    $scope.findingDatabases = $http.get(settings.apiHost + '/r/Importers');

    $scope.findingDatabases.then(function(response) {
      $scope.databases = [];
      angular.forEach(response.data, function(outlet) {
        if (outlet.companies.length > 0) {
          return;
        }

        if (outlet.lastSale || showAllDatabases) {
          $scope.databases.push(outlet);
        } else {
          $scope.databasesHidden = true;
        }
      });
    },
    function(response) {
      var message = response.data.message || 'Unable to list your databases at this time.';
      ngToast.danger(message);
    });
  };

  fetchDatabases();

  $scope.showAll = function() {
    showAllDatabases = true;
    fetchDatabases();
  };

  $scope.claimImporter = function() {
    $scope.claimingImporter = $http.post(settings.apiHost + '/r/Importers', {}, {params: {claimPin: $scope.registrationPin}});

    $scope.claimingImporter.then(function() {
      dialog.alert('Importer claim successful.');
      $scope.registrationPin = '';

      fetchDatabases();
    },
    function() {
      dialog.alert('Registration pin "' + $scope.registrationPin + '" is invalid');
    });
  };

  $scope.createCompany = function(outlet) {
    createCompanyModal = $uibModal.open({
      controller: 'SettingsCompanyCreateCtrl',
      templateUrl: 'modules/settings/company/create.tpl.html',
      backdrop: 'static',
      resolve: {
        outlet: function() {
          return outlet;
        }
      }
    }).result.then(function(newCompany) {
      if (newCompany) {
        $state.go('Settings.CompanyList', {}, {reload: true});
      }
    });
  };

  $scope.creteStandAloneCompany = function() {
    createCompanyModal = $uibModal.open({
      controller: 'SettingsCompanyCreateCtrl',
      templateUrl: 'modules/settings/company/create.tpl.html',
      backdrop: 'static',
      resolve: {
        outlet: function() {
          return {
            name: '',
            outletId: null
          };
        }
      }
    }).result.then(function(newCompany) {
      if (newCompany) {
        $state.go('Settings.CompanyList', {}, {reload: true});
      }
    });
  };

  $scope.statusMessage = function(database) {
    if (!database.lastSync) {
      return 'Completing initial import';
    } else if (moment(database.lastSync).isAfter(moment().subtract(5, 'minutes'))) {
      return 'Up to date';
    } else if (moment(database.status.SessionStartTime).isAfter(moment().subtract(5, 'minutes'))) {
      return 'Currently Importing';
    } else {
      return 'Importer offline';
    }
  };

  var pos = (localStorageService.get('signup-pos')) ? localStorageService.get('signup-pos') : false;
  var lddFirstRedirect = (localStorageService.get('first-redirect')) ? localStorageService.get('first-redirect') : false;
  console.log(pos);
  if (pos && !lddFirstRedirect) {
    $scope.creteStandAloneCompany();
  }
}]);
